import clsx from 'clsx';
import React from 'react';
import styles from './WideBlock.module.scss';
import { Button } from 'tt-ui-lib/core';
import CalcMenuButton from '../../../CalcMenuButton/CalcMenuButton';
import { CALC_TYPES } from 'utils/calculatorUtils';
import { useSelectedContext } from 'context/contextSelector';
import ReportDelete from 'views/ScoreAndReporting/components/ReportDelete/ReportDelete';

const WideBlock = (props) => {
  const { assessment, targetWidth, calcLogo, onViewClick, onMenuClick, refresh } = props;
  const { user } = useSelectedContext((context) => context.user);

  return (
    <div
      key={assessment.id}
      className={clsx(styles.rowWrapper, targetWidth < 940 && styles.shortFormat)}
    >
      <div className={styles.summary}>
        <div className={styles.draftName}>
          <div className={styles.title} title={assessment.name}>
            {assessment.name || '-'}
          </div>
          <div className={styles.calcInfo}>
            <span className={styles.dataValue}>Calculator</span>
          </div>
        </div>
        <div className={styles.infoBlock}>
          <div className={styles.dataItem}>
            <span className={styles.dataName}>Created: </span>
            <span className={styles.dataValue}>
              {assessment.periodReportDate.toISOString().slice(0, 10) ?? 'wrong date'}
            </span>
          </div>
          <div className={styles.dataItem}>
            <span className={styles.dataName}>Created by: </span>
            <span className={styles.dataValue}>
              {user.first_name} {user.last_name}
            </span>
          </div>
        </div>
      </div>
      <div className={clsx(styles.dataBlock, styles.buttonCont)}>
        <Button style={{ textWrap: 'nowrap' }} onClick={() => onViewClick(assessment.id)}>
          View more
        </Button>
        <ReportDelete
          type="icon"
          onDelete={refresh}
          draftId={assessment.id}
          draftName={assessment.name}
          buttonType="icon"
          isDraft={false}
        />
        <CalcMenuButton params={{ onMenuClick }} />
      </div>
    </div>
  );
};

export default WideBlock;
